export default __webpack_public_path__ + "static/media/3435 spice rack A side.52689c65.png";